<template>
    <div>

        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <!-- <v-tab class="font-weight-black" @click="getNotaNumerica()">Nota Numérica</v-tab> -->
            <v-tab class="font-weight-black" @click="getNotaLiteral()">Nota Literal</v-tab>
            <v-tab class="font-weight-black" @click="getEscalaEvaluativa()">Escala De Evaluación</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <!-- Componente configuracion nota numerica -->
            <!-- <v-tab-item class="py-4">
                <component class="mt-2" :is="compNotaNumerica" :parametros="parametroNotaNumerica"
                    :anios_lectivos="lectivos">
                </component>
            </v-tab-item> -->

            <v-tab-item class="py-4">
                <!-- Componente configuracion nota  literal -->
                <component class="mt-2" :is="compNotaLiteral" :parametros="parametroNotaLiteral" :anios_lectivos="lectivos">
                </component>
            </v-tab-item>

            <v-tab-item class="py-4">
                <!-- Componente escala evaluativa -->
                <component class="mt-2" :is="compEscalaEval" :parametros="parametroEscalaEval" :anios_lectivos="lectivos">
                </component>
            </v-tab-item>
        </v-tabs-items>



    </div>
</template>



<script>
import axios from '../../../helpers/axios'
import { mapMutations, mapGetters, mapActions } from 'vuex';

import NotaNumerica from '@/views/Mantenimiento/ConfiguracionEscalaEvaluativa/components/NotaNumerica.vue'
import NotaLiteral from '@/views/Mantenimiento/ConfiguracionEscalaEvaluativa/components/NotaLiteral.vue'
import EscalaEvaluativa from '@/views/Mantenimiento/ConfiguracionEscalaEvaluativa/components/EscalaEvaluativa.vue'


export default {
    name: 'configEscalaEval',

    components: {
        NotaNumerica,
        NotaLiteral,
        EscalaEvaluativa,
    },


    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 86, "id_modulo": 5 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        tab: 0,
        lectivos: [],

        // componente nota numerica
        compNotaNumerica: null,
        parametroNotaNumerica: {},


        // componente nota Literal
        compNotaLiteral: null,
        parametroNotaLiteral: {},


        // componente escala evaluativa
        compEscalaEval: null,
        parametroEscalaEval: {},
    }),



    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },


    mounted() {
        this.loadMain()
        this.getAllAnosLectivos()

    },


    created() {
        this.actualizarParamentro()
    },




    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ////////////////////////////////////////////////////////



        ////////// traer todos los años lectivos del colegio/////////
        async getAllAnosLectivos() {
            try {
                const response = await axios.get('/administrativo/anoLectivo/all/' + sessionStorage.id_colegio);
                this.lectivos = response.data

            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /////////////////////////////////////////////////////////////


        loadMain() {
            // this.getNotaNumerica()
            this.getNotaLiteral();
        },


        // componente nota numerica
        getNotaNumerica() {
            this.parametroNotaNumerica = {}
            this.compNotaNumerica = "NotaNumerica"
            this.compNotaLiteral = ""
            this.compEscalaEval = ""

        },



        // componente nota literal
        getNotaLiteral() {
            this.parametroNotaLiteral = {}
            this.compNotaLiteral = "NotaLiteral"
            this.compNotaNumerica = ''
            this.compEscalaEval = ""
        },




        // componente escala evaluativa
        getEscalaEvaluativa() {
            this.parametroEscalaEval = {}
            this.compEscalaEval = "EscalaEvaluativa"
            this.compNotaLiteral = ""
            this.compNotaNumerica = ''
        },


    },
}
</script>